// extracted by mini-css-extract-plugin
export default {"wrapper":"hxNkJjiQXcoLUauCPN9b","active":"XOFQU5gfQMOiyk8MUQNA"};